import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../../../../environments/environment';
import { UserViewService } from '../../../../../shared/sub-modules/user-views/services/user-view.service';
import { ReturnReason } from '../models/return-reason';

@Injectable({
  providedIn: 'root'
})
export class ReturnReasonsService extends UserViewService {
  protected urlBase = environment.urlReturns;
  constructor(http: HttpClient) {
    super('return-reasons', http);
  }
  list(): Observable<Array<ReturnReason>> {
    return this.http.get<Array<ReturnReason>>(this.url('list'));
  }
}
